module.exports = __webpack_public_path__ + "img/firework.503fd033.png";